import isArray from "lodash/isArray";

export function getQueryVariable(variable: string): string {
  const query = window.location.hash.substring(1);
  const vars = query.split("&");

  for (let i = 0; i < vars.length; i++) {
    const pairs = vars[i].split("=");
    if (decodeURIComponent(pairs[0]) === variable) {
      return decodeURIComponent(pairs[1]) as string;
    }
  }

  return "";
}

type UrlQueryValue = string | boolean | number;

interface ConvertToUrlQueryParams {
  [variable: string]: UrlQueryValue | UrlQueryValue[];
}

export function convertToUrlQuery(params: ConvertToUrlQueryParams): string {
  const queries: string[] = [];

  for (const key in params) {
    // cast value into an array
    const values = isArray(params[key]) ? params[key] : [params[key]];

    for (const value of values as UrlQueryValue[]) {
      queries.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }
  }

  return queries.join("&");
}
